var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, observable } from "mobx";
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
export class AggregatesViewPresenterBlockState {
    constructor(provider) {
        this.provider = provider;
        this.generalInfo = {};
    }
    activate() {
        this.provider.on(InternalMessageBusChannels.aggregatedEvents.generalInfo.update, this.updateGeneralData);
    }
    deactivate() {
        this.provider.off(InternalMessageBusChannels.aggregatedEvents.generalInfo.update, this.updateGeneralData);
        this.clearData();
    }
    updateGeneralData(message) {
        if (message.data[0] && message.data[0].generalInfo) {
            this.generalInfo = message.data[0].generalInfo;
        }
    }
    clearData() {
        this.generalInfo = {};
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AggregatesViewPresenterBlockState.prototype, "generalInfo", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AggregatesViewPresenterBlockState.prototype, "updateGeneralData", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AggregatesViewPresenterBlockState.prototype, "clearData", null);
//# sourceMappingURL=AggregatesViewPresenterBlockState.js.map